module.exports = __webpack_public_path__ + "static/example_image-4ad83ce3ef8dfc59a1fc5971c30baf13.jpg";